<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

@if (orderDetails && orderDetails.length > 0) {
  <p-table #pt [value]="orderDetails" [lazy]="false" dataKey="orderDetailId" selectionMode="single"
    [(selection)]="orderDetail" (onRowSelect)="onRowSelect($event)" [loading]="false" [paginator]="false" [rows]="25"
    [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true" [styleClass]="styleClass"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [tableStyle]="{'font-style': fontStyle, 'background-color': tableBackground}" [ngStyle]="{'background-color': tableBackground}">
    <ng-template pTemplate="header">
      @if (showHeaders) {
        <tr [class.small-headers]="compactHeader">
          @for (col of columns; track col) {
            <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
              {{col.header}}
            </th>
          }
        </tr>
      }
      @if (showFilter && showHeaders) {
        <tr [class.small-headers]="compactHeader">
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'orderDetailTaxId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'status', 'in')"></th>
          <!-- <th [ngStyle]="{'width': 'auto'}"></th> -->
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-orderDetail let-index="rowIndex">
      <tr [pSelectableRow]="orderDetail">
        @if (type==='Expense' && !hideServiceDate) {
          <td>{{orderDetail.serviceDate}}</td>
        }
        @if (!hideName) {
          <td>
            <div class="fw-bold">{{orderDetail.name}}</div>
            @if (type==='Expense') {
              <div class="text-muted">{{orderDetail.description}}</div>
            }
          </td>
        }
        @if (type==='Expense') {
          <td>{{orderDetail?.paidBy ? paidByList[orderDetail?.paidBy] : ''}}</td>
        }
        <td><b>{{orderDetail.quantity}}</b></td>
        <td>{{orderDetail.amount | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
        <td>{{orderDetail.subTotal | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
        <td>{{orderDetail.tax | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
        <td>{{orderDetail?.total | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
      </tr>
      @for (orderDetailTax of orderDetail.ownerStmtDetailTaxes; track orderDetailTax) {
        <tr class="detail-tax-row">
          @if (type==='Expense') {
            <td></td>
          }
          <td>{{orderDetailTax.taxName}}({{orderDetailTax?.taxRate}}%)</td>
          <td></td>
          <td></td>
          <td></td>
          @if (type==='Expense') {
            <td></td>
          }
          <td>{{orderDetailTax.taxAmount | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
          <td></td>
        </tr>
      }
      @if ((orderDetails.length - 1) == index) {
        <tr>
          <td></td>
          <td></td>
          <td></td>
          @if (type==='Expense') {
            <td></td>
          }
          <td>
            <span>Total Amount : </span>
            <span class="fw-bold">{{(type == 'Expense' ? reservation.expSubTotal : reservation.rezSubTotal) | currency : 'USD' : 'symbol' : '1.2-2'}}</span>
          </td>
          <td>
            <span>Total Taxes : </span>
            <span class="fw-bold">{{(type == 'Expense' ? reservation.expTax : reservation.rezTax) | currency : 'USD' : 'symbol' : '1.2-2'}}</span>
          </td>
          <td>
            <span>Grand Total : </span>
            <span class="fw-bold">{{(type == 'Expense' ? reservation.expTotal : reservation.rezTotal) | currency : 'USD' : 'symbol' : '1.2-2'}}</span>
          </td>
        </tr>
      }
    </ng-template>
  </p-table>
}


<p-dialog header="ReGenerate Invoice" [(visible)]="reGenerateInvoicePopUp" [style]="{width: 'auto'}">
  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3 mt-3">
      <!-- <input [(ngModel)]="amountReceived" id="amountReceived" type="text"  pInputText> -->
      <p-inputNumber class="w-100 eap-input" [(ngModel)]="amountReceived" id="amountReceived"
        inputId="currency-us" mode="currency" currency="USD" locale="en-US">
      </p-inputNumber>
      <label for="amountReceived">Amount Receieved</label>
    </span>
  </div>
  <div class="col-lg-12">
    <span class="p-float-label required-field w-100 mb-3">
      <button pButton class="btn-addt p-button" (click)="reGenerateInvoice()">Submit</button>
    </span>
  </div>
</p-dialog>

<p-dialog header="Add Travel Agent Fee" [(visible)]="addTravelAgentFeePopUp" [style]="{width: 'auto'}">
  <div [formGroup]="formTravelAgent" class="forms w-100 d-block" >
    <div class="row m-0">
      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3 mt-3">
          <input formControlName="agentName" id="agentName" type="text" pInputText>
          <label for="agentName">Agent Name</label>
        </span>
      </div>
      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3 mt-3">
          <input formControlName="agentPCT" id="agentPCT" type="text" pInputText>
          <label for="agentPCT">Agent PCT</label>
        </span>
      </div>
      <div class="col-lg-12">
        <span class="p-float-label required-field w-100 mb-3 mt-3">
          <input formControlName="privateNotes" id="privateNotes" type="text" pInputText>
          <label for="privateNotes">Private Notes</label>
        </span>
      </div>
    </div>
  </div>
  <hr>
    <div class="row m-0">
      <div class="col-lg-12">
        <div class="btn-group">
          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
            <button pButton class="btn-addt p-button" (click)="formAddTravelAgentFee()">Add Travel Agent Fee</button>
          </div>
        </div>
      </div>
    </div>

  </p-dialog>

  <p-dialog
    header="Rate Details"
    [modal]="true"
    [(visible)]="showOpsNoteDialog"
    [style]="{ width: '100rem', height:'100rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true">

    <div class="p-4">

      @for (opsNoteDetail of opsNoteDetails; track opsNoteDetail) {
        <table>
          <tr>
            <div class="d-flex">
              <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold; ">Property :</span>
              <span>{{opsNoteDetail.propertyCode}}</span>
            </div>
          </tr>
          <tr>
            <div class="d-flex">
              <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold; ">CheckIn :</span>
              <span>{{opsNoteDetail.checkInDate != null ? opsNoteDetail.checkInDate : checkInDate | date: 'yyyy-MM-dd'}}</span>
            </div>
          </tr>
          <tr>
            <div class="d-flex">
              <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">CheckOut :</span>
              <span>{{opsNoteDetail.checkOutDate != null ? opsNoteDetail.checkOutDate : checkOutDate | date: 'yyyy-MM-dd'}}</span>
            </div>
          </tr>
          <tr>
            <div class="d-flex">
              <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">Nights :</span>
              <span>{{opsNoteDetail.numNights}}</span>
            </div>
          </tr>
          <tr>
            <div class="d-flex">
              <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">List Price :</span>
              <span>{{opsNoteDetail.listPriceAMT | currency:'USD':'symbol':'1.2-2'}}</span><span>&nbsp; {{opsNoteDetail.listPriceAMT != null ? '(' : ''}} {{opsNoteDetail.listPriceAMT| currency:'USD':'symbol':'1.2-2'}} {{opsNoteDetail.listPriceAMT != null ? '/' : ''}} {{opsNoteDetail.numNights}} {{opsNoteDetail.listPriceAMT != null ? '=' : ''}} {{(opsNoteDetail.listPriceAMT / opsNoteDetail.numNights) | currency:'USD':'symbol':'1.2-2'}} {{opsNoteDetail.listPriceAMT != null ? ')' : ''}}</span>
            </div>
          </tr>
          <tr>
            <div class="d-flex">
              <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">Original Yield Price :</span>
              <span>{{opsNoteDetail.yieldPriceOrigAMT | currency:'USD':'symbol':'1.2-2'}}</span><span>&nbsp; {{opsNoteDetail.yieldPriceOrigAMT != null ? '(' : ''}} {{opsNoteDetail.yieldPriceOrigAMT | currency:'USD':'symbol':'1.2-2'}} {{opsNoteDetail.yieldPriceOrigAMT != null ? '/' : ''}} {{opsNoteDetail.numNights}} {{opsNoteDetail.yieldPriceOrigAMT != null ? '=' : ''}}  {{(opsNoteDetail.yieldPriceOrigAMT / opsNoteDetail.numNights) | currency:'USD':'symbol':'1.2-2'}} {{opsNoteDetail.yieldPriceOrigAMT != null ? ')' : ''}}</span>
            </div>
          </tr>
          <tr>
            <div class="d-flex">
              <span style="min-width: 170px;padding-right:10px; text-align:left; font-weight: bold;">Final Yield Price :</span>
              <span>{{opsNoteDetail.yieldPriceAMT | currency:'USD':'symbol':'1.2-2'}}</span><span>&nbsp; {{opsNoteDetail.yieldPriceAMT != null ? '(' : ''}} {{opsNoteDetail.yieldPriceAMT | currency:'USD':'symbol':'1.2-2'}} {{opsNoteDetail.yieldPriceAMT != null ? '/' : ''}} {{opsNoteDetail.numNights}} {{opsNoteDetail.yieldPriceAMT != null ? '=' : ''}} {{(opsNoteDetail.yieldPriceAMT / opsNoteDetail.numNights) | currency:'USD':'symbol':'1.2-2'}} {{opsNoteDetail.yieldPriceAMT != null ? ')' : ''}}</span>
            </div>
          </tr>
          <tr>
            <td style="min-width: 250px;padding-right:10px; padding-top: 10px; text-align:left; font-weight: bold;">
              <div class="d-flex gap-2">
                <a class="wiki-list-btn" href="javascript:void(0);" (click)="redirectToProperty(opsNoteDetail, 2)">Property</a>
                <a class="wiki-list-btn" href="javascript:void(0);" (click)="redirectToProperty(opsNoteDetail, 3)">Rate</a>
                <a class="wiki-list-btn" href="javascript:void(0);" (click)="redirectToProperty(opsNoteDetail, 4)">Seasons</a>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="2"><br><br><hr></td>
          </tr>
          @if (opsNoteDetail.logOutput) {
            <tr>
              <td colspan="2" style="white-space: pre-line;"><pre>{{opsNoteDetail.logOutput}}</pre></td>
            </tr>
          }
          @if (opsNoteDetail.opsNotes) {
            <tr>
              <td colspan="2" style="white-space: pre-line;"><pre>{{opsNoteDetail.opsNotes}}</pre></td>
            </tr>
          }
          @if (!opsNoteDetail.opsNotes) {
            <tr>
              <td colspan="2" style="white-space: pre-line;"><pre>Dynamic pricing adjustments not available</pre></td>
            </tr>
          }
        </table>
      }
    </div>
  </p-dialog>
